import React, { useEffect, useState } from 'react';
import api from '@/lib/api';

export const BASE = '/admin/acervo-sponte';
export const inp = 'rounded-lg border px-2 py-1.5 text-sm';
const REG = { BIMESTRAL: 'bg-sky-100 text-sky-800', TRIMESTRAL: 'bg-violet-100 text-violet-800', SEM_MATRIZ_COMPROVADA: 'bg-rose-100 text-rose-800' };

export const Badge = ({ r }) => <span className={`rounded px-2 py-0.5 text-[11px] font-bold ${REG[r] || 'bg-slate-100'}`}>{(r || '').replaceAll('_', ' ')}</span>;
export const Box = ({ children, testid }) => <div className="overflow-x-auto rounded-xl border bg-white p-3 text-sm" data-testid={testid}>{children}</div>;

// Valores técnicos da origem: nunca exibidos como dado "real".
export const Val = ({ v }) => {
  if (v === '-1' || v === -1) return <span className="rounded bg-slate-200 px-1 text-[11px]" title="Valor técnico da origem (-1), preservado">-1 (técnico)</span>;
  if (v === '' || v === null || v === undefined) return <span className="text-slate-400" title="Ausente na origem">ausente</span>;
  return <span>{String(v)}</span>;
};

export const Origem = ({ o }) => (
  <p className="mt-1 break-all text-[11px] text-slate-500" data-testid="acervo-origem">
    Fonte: {o?.zip || '—'} › {o?.arquivo || '—'} · tabela {o?.tabela} · ID {o?.id_original} · digest {o?.record_digest?.slice(0, 12)}… · lote {o?.lote?.slice(0, 8) || '—'}
  </p>
);

export const useGet = (url, params) => {
  const [d, setD] = useState(null);
  const key = JSON.stringify(params || {});
  useEffect(() => {
    setD(null);
    api.get(url, { params: JSON.parse(key) }).then(({ data }) => setD(data)).catch((e) => setD({ items: [], erro: e?.response?.status }));
  }, [url, key]);
  return d;
};

export const Pager = ({ d, pagina, setPagina, testid }) => (
  <div className="mt-2 flex items-center gap-2 text-xs" data-testid={testid}>
    <button type="button" className="rounded border px-2 py-1 disabled:opacity-40" disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)} data-testid={`${testid}-anterior`}>Anterior</button>
    <span>pág. {pagina} · {d?.total ?? 0} registros</span>
    <button type="button" className="rounded border px-2 py-1 disabled:opacity-40" disabled={!d || pagina * (d.limite || 50) >= d.total} onClick={() => setPagina(pagina + 1)} data-testid={`${testid}-proxima`}>Próxima</button>
  </div>
);
